import PolicyPage from '../components/PolicyPage';

const RefundAgreementPage = () => {
  return (
    <PolicyPage 
      title="Refund Agreement"
      metaTitle="Refund Agreement - Event Registration Refund Terms"
      metaDescription="Read the refund agreement for Golden Tree Events Dubai. Covers refund eligibility, cancellation timelines, processing procedures, and non-refundable conditions for event registrations."
      sourceUrl="https://gtedubai.com/app/refund-agreement?awd=gte"
    />
  );
};

export default RefundAgreementPage;
